function initCollectionSection() {
  const wrapper = document.querySelector(".collection-header-wrapper");
  const toggle = document.getElementById("collectionDesc");
  const toggleButton = document.getElementById("descToggle");

  if (!wrapper || !toggle || !toggleButton) return;

  // Assume there's a paragraph you need to clamp
  const paragraph = wrapper.querySelector("p");
  if (paragraph) {
    paragraph.classList.add("line-clamp-1");
  }

  // Attach click event to the wrapper to toggle description
  wrapper.addEventListener("click", function () {
    const isExpanded = toggle.classList.contains("expanded");
    if (!isExpanded) {
      toggle.style.height = paragraph.scrollHeight + "px";
    } else {
      toggle.style.height = paragraph.scrollHeight + "px"; // Set current height
      // Force reflow to ensure the browser registers it
      void toggle.offsetHeight;
      toggle.style.height = "2.2rem"; // Collapse height
    }

    toggle.classList.toggle("expanded");
    toggleButton.classList.toggle("expanded");
    paragraph.classList.toggle("line-clamp-1");
  });

  function closeMenuDrawer(){
    let menuWrapper = document.querySelector('.sf-menu-wrapper');
    let menu = document.querySelector('.sf-menu-content');
    menuWrapper.style.setProperty('--tw-bg-opacity', '0');
    menuWrapper.firstElementChild.classList.add('-translate-x-full');
      menuWrapper.classList.add('hidden');
      document.documentElement.classList.remove('prevent-scroll');
      menu.classList.remove('sf-sub-menu-open');
      menu.classList.remove('open-level-1', 'open-level-2'); // Close search
  }

      // Find all header items that trigger the radio click
      const headerTriggers = document.querySelectorAll('.header-trigger');

      headerTriggers.forEach(trigger => {
        trigger.addEventListener('click', function (e) {
          e.preventDefault(); // Prevent any default action, if needed

          // Retrieve the target radio input id
          const targetId = this.getAttribute('data-target-id');
          if (targetId) {
            const radioInput = document.getElementById(targetId);
              if (radioInput && !radioInput.disabled) {
                radioInput.click(); // Simulate a click on the radio input
                closeMenuDrawer();
              }
          }
        });
      });

      const allInputs = document.querySelectorAll('.facet-radio input[name="filter.p.m.product.problems"]');

      allInputs.forEach(input => {
        input.addEventListener('click', function (e) {
          // Retrieve the target radio input id
          if(this.checked) {
            const targetId = this.getAttribute('value');
            if (targetId) {
              const removeFacetFilter = document.querySelector(`facet-remove a[data-target-remove='${targetId}']`);
              if (removeFacetFilter && !removeFacetFilter.disabled) {
                this.checked = false; // Uncheck the input
                removeFacetFilter.click();
              }
            }
          }
        });
      });

  // Initialize mobile slider components (Swiper)
  const sliderElements = document.querySelectorAll(".mobile-slider-slide");
  sliderElements.forEach((sliderElement) => {
    new Swiper(sliderElement, {
      slidesPerView: 1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  });

}

function setupInfiniteScroll() {
  // tear down any old observer
  if (window._isObs) window._isObs.disconnect();

  const productGrid = document.querySelector("#product-grid");
  const trigger     = document.querySelector("#infinite-scroll-trigger");
  let nextUrl       = productGrid?.dataset.nextPageUrl;
  let loading       = false;

  if (!productGrid || !trigger || !nextUrl) return;

  const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting && !loading) {
      loading = true;

      fetch(`${nextUrl}${nextUrl.includes("?") ? "&" : "?"}section_id=${productGrid.dataset.id}`)
        .then(res => res.text())
        .then(html => {
          const doc     = new DOMParser().parseFromString(html, "text/html");
          const newGrid = doc.querySelector("#product-grid");
          const items   = newGrid.querySelectorAll("li");

          // append new items
          items.forEach(li => productGrid.appendChild(li));

          // grab the *new* next-page URL from the fetched HTML
          const newNext = newGrid.dataset.nextPageUrl || "";

          // **update your DOM** so the next init reads the right URL
          productGrid.setAttribute("data-next-page-url", newNext);

          // update our local var
          nextUrl = newNext;

          // if no more pages, kill the observer now
          if (!nextUrl) {
            observer.disconnect();
          }
        })
        .catch(console.error)
        .finally(() => {
          loading = false;
          // only re-init if there *is* a next page
          if (nextUrl) setupInfiniteScroll();
        });
    }
  }, {
    rootMargin: "200px 0px",
    threshold: 0.1
  });

  observer.observe(trigger);
  window._isObs = observer;
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderCollectionCustomFetch(html) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(html, 'text/html');
    const newSection = htmlDoc.querySelector('.collection-custom-fetch');
    if (newSection) {
      const targetSection = document.querySelector('.collection-custom-fetch');
      if (targetSection) {
        targetSection.innerHTML = newSection.innerHTML;
        initCollectionSection();
        setupInfiniteScroll();
      }
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    // Show loading state for product grid (adjust as needed)
    document.getElementById('ProductGridContainer')
      .querySelector('.collection').classList.add('loading');
    if (countContainer) countContainer.classList.add('loading');
    if (countContainerDesktop) countContainerDesktop.classList.add('loading');

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, section.type);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event, section.type);
      }
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event, sectionType) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

        if (sectionType === 'grid') {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        } else if (sectionType === 'collection') {
          FacetFiltersForm.renderCollectionCustomFetch(html);
        }
      }).then(() => {
          initCollectionSection();
          setupInfiniteScroll();
      });;
  }

  static renderSectionFromCache(filterDataUrl, event, sectionType) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    if (sectionType === 'grid') {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    } else if (sectionType === 'collection') {
      FacetFiltersForm.renderCollectionCustomFetch(html);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount')?.innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    if(count){
      container.innerHTML = count;
      container.classList.remove('loading');
      if (containerDesktop) {
        containerDesktop.innerHTML = count;
        containerDesktop.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '#ProductCountDesktop', '#ProductCountMobile', '#buttonApply'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
        type: 'grid'
      },
      {
        section: document.getElementById('collection-custom-fetch')?.dataset.id,
        type: 'collection'
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
    document.querySelectorAll('.js-filter input[type="checkbox"]').forEach(input => {
      input.closest('label')?.classList.toggle('active', input.checked);
    });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

setupInfiniteScroll();

document.addEventListener("DOMContentLoaded", function(){
    initCollectionSection();
    setupInfiniteScroll();
  const inputs = document.querySelectorAll("input[name='filter.p.m.product.producten']");
  const targetElement = document.querySelectorAll("#Filter-Producten-alle-producten")[0];

  let isChecked = false;

  inputs.forEach(input => {
    if (input.checked) {
      isChecked = true;
    }
  });

  if (!isChecked && targetElement) {
    targetElement.click();
  }
})